define([
	"csi/reflection",
	"csi/resolver"
], function(reflection, resolver) {

	const SUBTYPE_URL_PREFIX = reflection.URL_INSTANCE + "SelectSetSubtype/";

	const SITE_LEVEL_VIEW_NODE_TYPE = "_CS_Data";

	const SELECT_SET_TYPE_PDF_TYPE_DEF = {
		"ApparelBOM": "ApparelBOMs",
		"Category1": "StructureItem",
		"Category2": "StructureItem",
		"Collection": "StructureItem",
		"Colorway": "Colorway",
		"ColorMaterial": "ColorMaterial",
		"Material": "",
		"MaterialSupplierItem": "SupplierItemRevision",
		"PurchasedOrder": "PurchasedOrder",
		"SKU": "SKU",
		"SKUMaterial": "SKUMaterial",
		"Style": "",
		"StyleSupplierItem": "SupplierItemRevision",
		"Theme": "Theme"
	};

	const SELECT_SET_TYPE_BY_PARENT_VIEW_URL = {
		"centric://REFLECTION/INSTANCE/LibSourcing/SiteLibrary": "PurchasedOrder"
	};

	const SELECT_SET_TYPE_VIEW_REF_DEF = {
		"ApparelBOM": "AllApparelBOMs",
		"Category1": "Category1s",
		"Category2": "Category2s",
		"Collection": "Collections",
		"Colorway": "Colorways",
		"ColorMaterial": "ColoredMaterials",
		"Material": "AllMaterials",
		"MaterialSupplierItem": "AllMaterialSupplierItems",
		"PurchasedOrder": "PurchasedOrders",
		"SKU": "AllSKUs",
		"SKUMaterial": "SKUMaterials",
		"Style": "AllStyles",
		"StyleSupplierItem": "AllStyleSupplierItems",
		"Theme": "Themes"
	};

	const SELECT_SET_TYPE_ITEMS_VIEW_DEF = {
		"ApparelBOM": "ApparelBOMs",
		"Category1": "StructureItems",
		"Category2": "StructureItems",
		"Collection": "StructureItems",
		"Colorway": "ColorwayItems",
		"ColorMaterial": "ColorMaterialItems",
		"Material": "MaterialItems",
		"MaterialSupplierItem": "SupplierItems",
		"SKU": "SKUItems",
		"SKUMaterial": "SKUMaterialItems",
		"Style": "StyleItems",
		"StyleSupplierItem": "SupplierItems",
		"PurchasedOrder": "POItems",
		"Theme": "Themes"
	};

	const SELECT_SET_TYPE_ITEMS_GALLERY_DEF = {
		"ApparelBOM": "ApparelBOMsGallery",
		"Category1": "StructureItemsGallery",
		"Category2": "StructureItemsGallery",
		"Collection": "StructureItemsGallery",
		"Colorway": "ColorwayItemsGallery",
		"ColorMaterial": "ColorMaterialItemsGallery",
		"Material": "MaterialItemsGallery",
		"MaterialSupplierItem": "SupplierItemsGallery",
		"SKU": "SKUItemsGallery",
		"SKUMaterial": "SKUMaterialItemsGallery",
		"Style": "StyleItemsGallery",
		"StyleSupplierItem": "SupplierItemsGallery",
		"PurchasedOrder": "POItemsGallery",
		"Theme": "ThemesGallery"
	};

	/**
	 * Change gallery view id based on subtype
	 */
	function customizeLayout(tabsView, node, revisionNode) {
		tabsView.tabs[1].m_idView = SELECT_SET_TYPE_ITEMS_GALLERY_DEF[getSubtypeName(node)];
	}

	function getItemTypeBySubtype(/*String*/subtype) {
		return (subtype == "StyleSupplierItem" || subtype == "MaterialSupplierItem") ? "SupplierItem" : subtype;
	}

	function getNameFromURL(/*String*/urlSubtype) {
		if (urlSubtype && urlSubtype.indexOf(SUBTYPE_URL_PREFIX) == 0) {
			return urlSubtype.substring(SUBTYPE_URL_PREFIX.length);
		}

		return null;
	}

	function getPdfType(/*Node*/nodeSelectSet) {
		return SELECT_SET_TYPE_PDF_TYPE_DEF[getSubtypeName(nodeSelectSet)];
	}

	function getPdfTypeFromURL(/*URL*/urlSubtype) {
		return SELECT_SET_TYPE_PDF_TYPE_DEF[getNameFromURL(urlSubtype)];
	}

	function getSubtypeName(/*Node*/nodeSelectSet) {
		return getNameFromURL(nodeSelectSet && nodeSelectSet.Subtype);
	}

	function resolveSelectSetType(/*URL*/parentViewNodeUrl) {
		let type = SELECT_SET_TYPE_BY_PARENT_VIEW_URL[parentViewNodeUrl];
		const parentViewNode = resolver.resolveNode(parentViewNodeUrl, true);
		if (!type) {
			type = parentViewNode.$Type;
		}
		if (type == "SupplierItemRevision" || type == "SupplierItem") {
			const master = (type == "SupplierItemRevision") ? resolver.resolveNode(parentViewNode.Master, true) : parentViewNode;
			const productSource = resolver.resolveNode(master.__Parent__, true);
			const productSourcing = resolver.resolveNode(productSource.__Parent__, true);
			type = (productSourcing.$Type == "StyleSourcing" ? "Style" : "Material") + master.$Type;
		}
		return type;
	}

	return {
		SUBTYPE_URL_PREFIX,
		SITE_LEVEL_VIEW_NODE_TYPE,
		SELECT_SET_TYPE_PDF_TYPE_DEF,
		SELECT_SET_TYPE_BY_PARENT_VIEW_URL,
		SELECT_SET_TYPE_VIEW_REF_DEF,
		SELECT_SET_TYPE_ITEMS_VIEW_DEF,
		SELECT_SET_TYPE_ITEMS_GALLERY_DEF,

		customizeLayout,
		getItemTypeBySubtype,
		getNameFromURL,
		getPdfType,
		getPdfTypeFromURL,
		getSubtypeName,
		resolveSelectSetType,
	};
});